import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Link from '@material-ui/core/Link';
import { useAuthContext, useLoadingContext } from '@hooks';
import InputTextOutlined from '@components/InputTextOutlined';
import PrimaryButton from '@components/PrimaryButton';
import { AuthLayout } from '@layouts';
import { switchBetweenLabelAndPlaceholder } from '@utils';

function SignIn({
  screen,
  open,
  OpenVerificationScreen,
  email,
  setEmail,
  title,
  subTitle,
  root,
  handleClose,
}) {
  const { setIsLoading } = useLoadingContext();

  const [isPlaceholderEmailShow, setPlaceholderEmailShow] = useState(true);
  const [isLabelEmailShow, setLabelEmailShow] = useState(false);
  const { establishSession } = useAuthContext();
  const { t } = useTranslation('auth');

  const handleChangeEmail = ({ target }) => {
    setEmail(target.value);

    switchBetweenLabelAndPlaceholder({
      condition: target.value.length > 0,
      setLabel: setLabelEmailShow,
      setPlaceholder: setPlaceholderEmailShow,
    });
  };

  const handleDisplayPlaceholderInput = () => {
    setPlaceholderEmailShow(!isPlaceholderEmailShow);
  };

  const handleDisplayLabelOrPlaceholder = () => {
    if (email.length > 0) {
      setLabelEmailShow(true);
    } else {
      setPlaceholderEmailShow(true);
    }
  };

  const signInEmail = async () => {
    setIsLoading(true);
    await establishSession(email);
    OpenVerificationScreen();
    setIsLoading(false);
  };

  const useAnonymousFlow = async () => {
    setIsLoading(true);
    if (screen === 'visit') {
      sessionStorage.setItem('showVisit', screen);
    }
    if (screen === 'pay') {
      sessionStorage.setItem('showPay', screen);
    }
    await establishSession();
    handleClose();
    setIsLoading(false);
  };

  return (
    <AuthLayout
      title={title}
      subTitle={subTitle}
      open={open}
      root={root}
      handleClose={useAnonymousFlow}
    >
      <>
        <InputTextOutlined
          styles={{ marginTop: 20, marginBottom: 30 }}
          type="email"
          value={email}
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
          placeholder={t('placeholders.email')}
          handleChangeInput={handleChangeEmail}
          handleDisplayPlaceholderInput={handleDisplayPlaceholderInput}
          handleDisplayLabelOrPlaceholder={handleDisplayLabelOrPlaceholder}
          isPlaceholderInputDisplayed={isPlaceholderEmailShow}
          isLabelInputDisplayed={isLabelEmailShow}
          required
        />
        <PrimaryButton
          text={t('signIn.sendCode')}
          handleClick={signInEmail}
          isDisabledButton={!email}
        />
        <Link
          style={{ textAlign: 'center' }}
          target="_blank"
          href={'https://waitless.ai/why-sign-in/'}
          to={'https://waitless.ai/why-sign-in/'}
        >
          Why sign in?
        </Link>
      </>
    </AuthLayout>
  );
}

export default SignIn;
